import React from 'react';
import { useConfig } from '@providers';

type Props = {
  url: string;
};

const IpidLink = ({ url }: Props) => {
  const { phrases } = useConfig();
  const text = phrases['shared.ipidLink'];
  return <a href={url} target="_blank" rel="noreferrer">{text}</a>;
};

export default IpidLink;
